export const environment = {
  production: false,
  hmr: false,
  baseUrl: 'https://uat-work.insureco.io',
  google: {
    reCaptcha: {
      siteKey: '6LcoJP0UAAAAAG98d_TVB1pVYCsxPK_U2Va6DpYO',
    },
    oAuth: {
      clientId: '447668739643-40vodfs0frl3c9f9p68nk1umumg7iih6.apps.googleusercontent.com',
    },
  },
  plaid: {
    env: 'sandbox',
    clientName: 'Insureco',
    key: '0410343e996ed6cc28cbb25bbfa58c',
    product: ['auth'],
  },
  stripe: {
    publicKey: 'pk_test_Qnd38mv665iSkePn8kzlw761',
  },
  VAPID_PUBLIC:
    'BHYguZo8qOT2_bJGrv8_VvfcSztCFS1PU1Htf4uhJqK7fefHcskgGMLonLmbVwPNOove0hLwzvdvrSRnJqIIjac',
  defaultPostLoginPath: '/dashboard',
};
